import { Injectable } from '@angular/core';
import { JeevesCustomerContactListConfigService } from 'gung-standard-jeeves';

@Injectable({
  providedIn: 'root'
})
export class ColmecCustomerContactListingConfigService extends JeevesCustomerContactListConfigService {}
